import { Check, CircleOutlined } from '@mui/icons-material'
import { Box, CardActionArea, CardMedia } from '@mui/material'

interface CardActionsAreaProps {
  product: any
  loadingVideo: boolean
  handleActionAreaClick: () => void
  productosSeleccionados: any[]
  setProductosSeleccionados: (productos: any[]) => void
  isAdmin?: boolean
}

const CardActionsArea = ({
  product,
  loadingVideo,
  handleActionAreaClick,
  productosSeleccionados,
  setProductosSeleccionados,
  isAdmin
}: CardActionsAreaProps) => {
  return (
    <CardActionArea>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 1,
          padding: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '0 0 0 10px'
        }}
      >
        <Box>
          {productosSeleccionados.some((p: any) => p.codProducto === product.codProducto) ? (
            <Check
              color="primary"
              onClick={() =>
                setProductosSeleccionados(
                  productosSeleccionados.filter((p: any) => p.codProducto !== product.codProducto)
                )
              }
            />
          ) : (
            <CircleOutlined
              color="inherit"
              onClick={() => setProductosSeleccionados([...productosSeleccionados, product])}
            />
          )}
        </Box>
      </Box>
      <CardMedia
        onClick={!loadingVideo && handleActionAreaClick}
        component={'img'}
        loading="lazy"
        sx={{
          height: 200,
          objectFit: 'scale-down',
          //not allow to select image
          userSelect: 'none'
        }}
        image={isAdmin ? product.urlFoto : product.fotoUrlThumb}
        title={product.nombre}
      />
    </CardActionArea>
  )
}

export default CardActionsArea
